import axios from "axios";
import { getArtistDataByUsrHandleApi } from "../_constants/api.constant";
import { getSelfToken } from '../../_helpers/auth/secureToken'
export async function getArtistDataByUserHandle(userHandle) {
    const response = await axios.get(
        getArtistDataByUsrHandleApi.GET+'?search='+ userHandle,
        {
            headers: {
                Authorization: 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        // handle error
        console.log(error);
        console.log(error.response);
        return error.response;
    });
    return response;
}